import { Box, CircularProgress } from "@mui/material";

export default function StepPolling({ pollingTime }) {
  return (
    <>
      <span>
        Estamos verificando a conexão do seu WhatsApp.
        <strong> Não feche esta página.</strong>
        <br />
        <span style={{ fontSize: 14, opacity: 0.7 }}>
          Tempo restante: {Math.max(0, 120 - pollingTime)}s
        </span>
      </span>

      <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
        <CircularProgress size={80} thickness={2} />
      </Box>
    </>
  );
}
